function Transportation(tr) {
  this.id = tr.id;
  this.type = tr.type;
  this.calculationUid = tr.calculation_uid;
  this.peopleCount = tr.people_count;
  this.timeOnWay = tr.time_on_way;
  this.floorWithLift = tr.floor_with_lift;
  this.floorWithoutLift = tr.floor_without_lift;
  this.distanceFromParking = tr.distance_from_parking;
  this.distance = tr.distance;
  this.transportPrice = tr.transport_price;
  this.packagingPrice = tr.packaging_price;
  this.itemList = [];
}

export default Transportation;